var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"append-icon":"mdi-magnify","label":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_c('v-data-table',{attrs:{"dense":"","items":_vm.items,"headers":_vm.config.headers,"search":_vm.search},on:{"dblclick:row":_vm.editItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }